import { render, staticRenderFns } from "./LogWeight.vue?vue&type=template&id=028aeeac&scoped=true&lang=pug&"
import script from "./LogWeight.vue?vue&type=script&lang=js&"
export * from "./LogWeight.vue?vue&type=script&lang=js&"
import style0 from "./LogWeight.vue?vue&type=style&index=0&id=028aeeac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028aeeac",
  null
  
)

export default component.exports